import { EMPTY_OBJECT } from '../../../../../constants/common'
import { AppointmentFormModal } from '../../../../Appointment'

export function useCalendarViewAppointmentCreate({
  setModal,
  onClose,
  onReload,
}) {
  function handleOpenAppointmentCreate({
    end,
    firstDay,
    lastDay,
    start,
  } = EMPTY_OBJECT) {
    setModal(
      <AppointmentFormModal
        end={end}
        firstDay={firstDay}
        lastDay={lastDay}
        start={start}
        onClose={onClose}
        onSaved={onReload}
      />
    )
  }

  // A clicked hour cell gives the start, the form its default length (CAL-02 §7.3 rule 5)
  function handleClickEmptyCell(start) {
    handleOpenAppointmentCreate({ start })
  }

  return { handleClickEmptyCell, handleOpenAppointmentCreate }
}
